import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageSelect, EditPageCheckbox } from '../../../../common/EditPage';
import { useNavigate } from 'react-router-dom';
import { getOne, create } from '../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const AccessRightsCreate = () => {
    const [data, setData] = useState({
        can_read: false,
        can_write: false
    });
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    
    useEffect(() => {
        getOne(`/admin/access/rights/`, 'new').then(response => {
            setMetadata(response.data.metadata);
        }).catch(error => {
            toast.error("Error fetching access rights metadata: " + error.message, {});
        });
    }, []);

    const handleSave = () => {
        create(`/admin/access/rights/`, {data: data}).then(() => {
            navigate(`/admin/access/rights`);
        }).catch(error => {
            toast.error("Error creating access right: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/admin/access/rights`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageSelect 
                        label="Access Group" 
                        id="access_group_id" 
                        onChange={onChange} 
                        value={data.access_group_id}
                        options={metadata?.groups}
                        required
                    />
                    <EditPageSelect 
                        label="Access Area" 
                        id="access_area_id" 
                        onChange={onChange} 
                        value={data.access_area_id}
                        options={metadata?.areas}
                        required
                    />
                    <EditPageCheckbox 
                        label="Can Read" 
                        id="can_read" 
                        onChange={onChange} 
                        value={data.can_read}
                    />
                    <EditPageCheckbox 
                        label="Can Write" 
                        id="can_write" 
                        onChange={onChange} 
                        value={data.can_write}
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default AccessRightsCreate; 